// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DefaultTheme__modal-header___3-lo2 {
  --_apc-modal-header-border-radius:
    var(
      --_apc-modal-header-border-radius-lume,
      4px 4px 0 0
    );

  display: flex;
  flex-direction: row;
  padding: 20px 30px;
  background-color: var(--_apc-modal-header-background-color, var(--aluminum1));
  border-bottom: var(--_apc-modal-header-border-bottom, 1px solid var(--aluminum2));
  border-radius: var(--_apc-modal-header-border-radius);
  flex: 0 0 auto;
  color: var(--_apc-modal-header-color, var(--steel3));
}

  .DefaultTheme__modal-header___3-lo2 h1,
  .DefaultTheme__modal-header___3-lo2 h2,
  .DefaultTheme__modal-header___3-lo2 h3,
  .DefaultTheme__modal-header___3-lo2 h4 {
    --_apc-modal-header-font-weight: var(--_apc-modal-header-font-weight-lume, 700);
    --_apc-modal-header-font-size: var(--_apc-modal-header-font-size-lume, 32px);

    margin-top: 0;
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
    flex: 1 1 auto;
    font-size: var(--_apc-modal-header-font-size);
    font-weight: var(--_apc-modal-header-font-weight);
  }

  .DefaultTheme__modal-header___3-lo2.DefaultTheme__danger___2Gh6V {
    background-color: var(--_apc-modal-header-danger-background-color, var(--danger));
    color: var(--_apc-modal-header-danger-color, var(--tertiary));
  }

  .DefaultTheme__modal-header___3-lo2.DefaultTheme__danger___2Gh6V h1,
    .DefaultTheme__modal-header___3-lo2.DefaultTheme__danger___2Gh6V h2,
    .DefaultTheme__modal-header___3-lo2.DefaultTheme__danger___2Gh6V h3,
    .DefaultTheme__modal-header___3-lo2.DefaultTheme__danger___2Gh6V h4 {
      color: var(--_apc-modal-header-danger-color, var(--tertiary));
    }

  .DefaultTheme__modal-header___3-lo2.DefaultTheme__danger___2Gh6V .DefaultTheme__close___3T_6- {
      fill: var(--tertiary);
    }

  .DefaultTheme__modal-header___3-lo2 button {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    transition: box-shadow .15s cubic-bezier(.46,.03,.52,.96);
    height: 24px;
    width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: transparent solid 1px;
  }

  .DefaultTheme__modal-header___3-lo2 button span {
      display: flex;
      align-items: center;
    }

  .DefaultTheme__modal-header___3-lo2 button svg {
      height: 20px;
      width: 20px;
    }

  .DefaultTheme__modal-header___3-lo2 button:focus {
    box-shadow: var(--lume-g-color-neutral-100) 0px 0px 0px 2px,  var(--core-blue3) 0px 0px 0px 4px;
  }
`, "",{"version":3,"sources":["webpack://./../node_modules/@mulesoft/anypoint-components/raw/components/ModalHeader/themes/DefaultTheme.css"],"names":[],"mappings":"AAAA;EACE;;;;KAIG;;EAEH,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6EAA6E;EAC7E,iFAAiF;EACjF,qDAAqD;EACrD,cAAc;EACd,oDAAoD;AACtD;;EAEE;;;;IAIE,+EAA+E;IAC/E,4EAA4E;;IAE5E,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,6CAA6C;IAC7C,iDAAiD;EACnD;;EAEA;IACE,iFAAiF;IACjF,6DAA6D;EAC/D;;EAEA;;;;MAII,6DAA6D;IAC/D;;EAEF;MACI,qBAAqB;IACvB;;EAEF;IACE,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,UAAU;IACV,yDAAyD;IACzD,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;EAChC;;EAEA;MACI,aAAa;MACb,mBAAmB;IACrB;;EAEF;MACI,YAAY;MACZ,WAAW;IACb;;EAEF;IACE,+FAA+F;EACjG","sourcesContent":[".DefaultTheme__modal-header___3-lo2 {\n  --_apc-modal-header-border-radius:\n    var(\n      --_apc-modal-header-border-radius-lume,\n      4px 4px 0 0\n    );\n\n  display: flex;\n  flex-direction: row;\n  padding: 20px 30px;\n  background-color: var(--_apc-modal-header-background-color, var(--aluminum1));\n  border-bottom: var(--_apc-modal-header-border-bottom, 1px solid var(--aluminum2));\n  border-radius: var(--_apc-modal-header-border-radius);\n  flex: 0 0 auto;\n  color: var(--_apc-modal-header-color, var(--steel3));\n}\n\n  .DefaultTheme__modal-header___3-lo2 h1,\n  .DefaultTheme__modal-header___3-lo2 h2,\n  .DefaultTheme__modal-header___3-lo2 h3,\n  .DefaultTheme__modal-header___3-lo2 h4 {\n    --_apc-modal-header-font-weight: var(--_apc-modal-header-font-weight-lume, 700);\n    --_apc-modal-header-font-size: var(--_apc-modal-header-font-size-lume, 32px);\n\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    flex: 1 1 auto;\n    font-size: var(--_apc-modal-header-font-size);\n    font-weight: var(--_apc-modal-header-font-weight);\n  }\n\n  .DefaultTheme__modal-header___3-lo2.DefaultTheme__danger___2Gh6V {\n    background-color: var(--_apc-modal-header-danger-background-color, var(--danger));\n    color: var(--_apc-modal-header-danger-color, var(--tertiary));\n  }\n\n  .DefaultTheme__modal-header___3-lo2.DefaultTheme__danger___2Gh6V h1,\n    .DefaultTheme__modal-header___3-lo2.DefaultTheme__danger___2Gh6V h2,\n    .DefaultTheme__modal-header___3-lo2.DefaultTheme__danger___2Gh6V h3,\n    .DefaultTheme__modal-header___3-lo2.DefaultTheme__danger___2Gh6V h4 {\n      color: var(--_apc-modal-header-danger-color, var(--tertiary));\n    }\n\n  .DefaultTheme__modal-header___3-lo2.DefaultTheme__danger___2Gh6V .DefaultTheme__close___3T_6- {\n      fill: var(--tertiary);\n    }\n\n  .DefaultTheme__modal-header___3-lo2 button {\n    background: none;\n    color: inherit;\n    border: none;\n    padding: 0;\n    transition: box-shadow .15s cubic-bezier(.46,.03,.52,.96);\n    height: 24px;\n    width: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    outline: transparent solid 1px;\n  }\n\n  .DefaultTheme__modal-header___3-lo2 button span {\n      display: flex;\n      align-items: center;\n    }\n\n  .DefaultTheme__modal-header___3-lo2 button svg {\n      height: 20px;\n      width: 20px;\n    }\n\n  .DefaultTheme__modal-header___3-lo2 button:focus {\n    box-shadow: var(--lume-g-color-neutral-100) 0px 0px 0px 2px,  var(--core-blue3) 0px 0px 0px 4px;\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
